import { render, staticRenderFns } from "./UnresponsiveClientsThirdAttempt.vue?vue&type=template&id=e2d331bc&scoped=true&"
import script from "./UnresponsiveClientsThirdAttempt.vue?vue&type=script&lang=js&"
export * from "./UnresponsiveClientsThirdAttempt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d331bc",
  null
  
)

export default component.exports